import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash'

@Component({
  selector: 'cargoes-business-icons',
  templateUrl: './business-icons.component.html',
  styleUrls: ['./business-icons.component.css']
})
export class BusinessIconsComponent implements OnInit {

  @Input() defaultFormData: any;
  @Output() iconClick = new EventEmitter<string>();
  iconList: any[] = [];
  iconTooltip: any;
  iconType: any[] = [];

  constructor() { }

  readonly _transportModes = {
    MARITIME_TRANSPORT: 'Maritime',
    RAIL_TRANSPORT: 'Rail',
    ROAD_TRANSPORT: 'Road',
    AIR_TRANSPORT: 'Air',
    MAIL: 'Mail',
    MULTIMODAL_TRANSPORT: 'Multimodal',
    INLAND_WATER_TRANSPORT: 'InlandWater',
    FIXED_TRANSPORT_INSTALLATION: 'FixedTransport',
    TRANSPORTATION_NA: 'TransportModeNotApplicable'
  }

  readonly _inspectionType = {
    DV: 'DV',
    PT14_SI: 'SI',
    SI: 'SI',
    PT19_PI: 'PI',
    PI: 'PI',
    PCA: 'PCA',
    CI: 'CI'
  }


  ngOnInit() {

    if ((this.defaultFormData) && (this.defaultFormData.trim() != '')) {
      this.iconList = this.defaultFormData
        .replace(/\s/g, "").split(',')
        .filter(function (data: string | null) {
          return data != null && data != "";
        })

      _.uniq(this.iconList).forEach(element => {
        if (element.includes('SI') && !_.some(this.iconType, o => o["tooltip"] === 'Sampling Inspection')) {
          this.iconType.push({
            icon: "customs-lab",
            iconType: "SI",
            color: "red",
            tooltip: "Sampling Inspection"
          })
        }
        if (element.includes('PI') && !_.some(this.iconType, o => o["tooltip"] === 'Physical Inspection')) {
          this.iconType.push({
            icon: "customs-police",
            iconType: "PI",
            color: "blue",
            tooltip: "Physical Inspection"
          })
        }
        if (element.includes('DV') && !_.some(this.iconType, o => o["tooltip"] === 'Documents Inspection')) {
          this.iconType.push({
            icon: "customs-file-text",
            iconType: "DV",
            color: "green",
            tooltip: "Documents Inspection"
          })
        }

        if (element.includes('PCA') && !_.some(this.iconType, o => o["tooltip"] === 'Post Clearance Audit')) {
          this.iconType.push({
            icon: "receipt",
            iconType: "DV",
            color: "orange",
            tooltip: "Post Clearance Audit"
          })
        }

        if (element.includes('CI') && !_.some(this.iconType, o => o["tooltip"] === 'Canine Inspection')) {
          this.iconType.push({
            icon: "security-scan",
            iconType: "CI",
            color: "purple",
            tooltip: "Canine Inspection"
          })
        }

        if (element.includes(this._transportModes.MARITIME_TRANSPORT)) {
          this.iconType.push({
            icon: "customs-maritime-transport",
            iconType: "maritime-transport",
            color: "blue",
            tooltip: "Maritime Transport"
          })
        }

        if (element.includes(this._transportModes.ROAD_TRANSPORT)) {
          this.iconType.push({
            icon: "customs-road-transport",
            iconType: "road-transport",
            color: "blue",
            tooltip: "Road Transport"
          })
        }

        if (element.includes(this._transportModes.RAIL_TRANSPORT)) {
          this.iconType.push({
            icon: "customs-rail-transport",
            iconType: "rail-transport",
            color: "blue",
            tooltip: "Rail Transport"
          })
        }

        if (element.includes(this._transportModes.AIR_TRANSPORT)) {
          this.iconType.push({
            icon: "customs-air-transport",
            iconType: "air-transport",
            color: "blue",
            tooltip: "Air Transport"
          })
        }

        if (element.includes(this._transportModes.MAIL)) {
          this.iconType.push({
            icon: "customs-mail",
            iconType: "customs-mail",
            color: "blue",
            tooltip: "Mail"
          })
        }
        if (element.includes(this._transportModes.MULTIMODAL_TRANSPORT)) {
          this.iconType.push({
            icon: "customs-maritime-transport",
            iconType: "maritime-transport",
            color: "blue",
            tooltip: "Maritime Transport"
          })
          this.iconType.push({
            icon: "customs-road-transport",
            iconType: "road-transport",
            color: "blue",
            tooltip: "Road Transport"
          })
          this.iconType.push({
            icon: "customs-air-transport",
            iconType: "air-transport",
            color: "blue",
            tooltip: "Air Transport"
          })
          this.iconType.push({
            icon: "customs-rail-transport",
            iconType: "rail-transport",
            color: "blue",
            tooltip: "Rail Transport"
          })
        }

        if (element.includes(this._transportModes.INLAND_WATER_TRANSPORT)) {
          this.iconType.push({
            icon: "customs-maritime-transport",
            iconType: "maritime-transport",
            color: "blue",
            tooltip: "Inland Water Transport"
          })
        }

        if (element.includes(this._transportModes.FIXED_TRANSPORT_INSTALLATION)) {
          this.iconType.push({
            icon: "cargoes-fixed-transport",
            iconType: "cargoes-fixed-transport",
            color: "blue",
            tooltip: "Fixed Transport Installations"
          })
        }

        if (element.includes(this._transportModes.TRANSPORTATION_NA)) {
          this.iconType.push({
            icon: "cargoes-transport-mode-na",
            iconType: "cargoes-transport-mode-na",
            color: "blue",
            tooltip: "Transport Mode Not Applicable"
          })
        }
        if (element.includes("NA")) {
          this.iconType.push({
            icon: "",
            iconType: "NA",
            color: "",
            tooltip: "NA"
          })
        }
      });
    }


  }

  iconClicked(event: any) {
    this.iconClick.emit(event);
  }
}
